import { render, staticRenderFns } from "./PhotoDetailView.vue?vue&type=template&id=370cf5a1&scoped=true"
import script from "./PhotoDetailView.vue?vue&type=script&lang=js"
export * from "./PhotoDetailView.vue?vue&type=script&lang=js"
import style0 from "./PhotoDetailView.vue?vue&type=style&index=0&id=370cf5a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370cf5a1",
  null
  
)

export default component.exports